import { Icon, IconsEnum } from 'components/Icons';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';
import { useGetLabelsByKeys, useTranslation } from 'hooks/useLingUI';

import { ItemWithTranslation } from 'types/swagger';
import classNames from 'classnames';
import { selectIsScommessaLoading } from 'features/sport';
import { setAccordionFilter } from 'features/sport/sportSlice';
import styles from './ScommesseAccordionFilterPrimary.module.scss';

export type ScommesseAccordionFilterPrimaryProps = ItemWithTranslation<{ label?: string; selectedFilter?: string }> & {
  children?: React.ReactNode;
  hasMarginBotton?: boolean;
  isBig?: boolean;
  hasShowMore?: boolean;
  className?: string;
  isAccordionOpened?: boolean;
  isEverythingVisible?: boolean;
  hasMarginRight?: boolean;
  classNameContainer?: string;
  noHeaderVisible?: boolean;
};

export const ScommesseAccordionFilterPrimary = ({
  label,
  labelTrKey,
  selectedFilter,
  selectedFilterTrKey,
  children,
  hasMarginBotton,
  isBig,
  hasShowMore,
  className,
  isAccordionOpened,
  isEverythingVisible,
  hasMarginRight,
  classNameContainer,
  noHeaderVisible,
}: ScommesseAccordionFilterPrimaryProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showMoreLabel, showLessLabel] = useGetLabelsByKeys(['show-more', 'show-less']);

  // should be on buttons, but here is most centralized
  const isScommessaLoading = useTypedSelector(selectIsScommessaLoading);

  useEffect(() => {
    if (isAccordionOpened) {
      setIsOpen(isAccordionOpened);
      dispatch(setAccordionFilter(isAccordionOpened));
    }
  }, [dispatch, isAccordionOpened]);

  return (
    <div
      className={classNames(
        styles.container,
        { [styles.marginBottom]: hasMarginBotton, [styles.marginRight]: hasMarginRight },
        classNameContainer ?? ''
      )}
    >
      {!noHeaderVisible && (
        <p className={styles.header}>
          {t(labelTrKey, label)}
          {selectedFilter && (
            <React.Fragment>
              &nbsp;-&nbsp;<span>{t(selectedFilterTrKey, selectedFilter)}</span>
            </React.Fragment>
          )}
        </p>
      )}
      <div
        className={classNames(
          styles.main,
          isOpen ? styles.visible : styles.hidden,
          { [styles.bigger]: isBig, [styles.visible]: isEverythingVisible, [styles.disabled]: isScommessaLoading },
          className ?? ''
        )}
      >
        {children}
      </div>
      {hasShowMore && (
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <Icon
            iconId={isOpen ? IconsEnum.MINUS_CIRCLE : IconsEnum.PLUS_CIRCLE}
            className={styles.icon}
            color="var(--color-primary)"
          />
          {isOpen ? showLessLabel : showMoreLabel}
        </button>
      )}
    </div>
  );
};
